import { createStyles } from "@mantine/emotion";

export const useStylesFileManager = createStyles((theme) => ({
  fileManager: {
    ".text": {
      fontSize: theme.spacing.fileManager.fileTextFontSize,
      fontWeight: "normal",
      textAlign: "center",
    },

    ".file-context-menu-list ul div:not(:first-of-type):not(:nth-of-type(5)), .toolbar, .file-select-all, .file-action-container div button:not(:nth-of-type(4)), .files.list .file-item .selection-checkbox, .fm-context-menu":
      {
        display: "none",
      },

    ".navigation-pane": {
      [`@media (max-width: ${theme.breakpoints.tabletMax})`]: {
        display: "none",
      },
    },

    ".folders-preview": {
      [`@media (max-width: ${theme.breakpoints.tabletMax})`]: {
        width: "100% !important",
      },
    },

    ".toolbar": {
      minHeight: theme.spacing.fileManager.toolbarMinHeight,
    },

    ".sb-folders-list .active-list-item:hover, .sb-folders-list .active-list-item, .files .file-item:hover, .files .file-selected, .fm-button-primary":
      {
        background: "none",
      },

    ".files.list .file-item-container.file-selected:hover, .files .file-selected, .sb-folders-list .active-list-item, .bread-crumb-container .breadcrumb .folder-name:hover":
      {
        background: "none !important",
        color: theme.customColors.black,
      },

    ".rename-file, .fm-upload-file .select-files .draggable-file-input:hover, .fm-upload-file .select-files .draggable-file-input.dragging":
      {
        borderColor: theme.customColors.blackLight,
      },

    ".toolbar .icon-only:hover": {
      color: theme.customColors.blackLight,
    },

    ".sb-folder-name": {
      width: `calc(100% - ${theme.spacing.fileManager.folderNameWidthOffset}) !important`,
    },

    ".folder-open-icon": {
      width: theme.spacing.fileManager.folderIconSize,
    },

    ".bread-crumb-container .breadcrumb": {
      maxHeight: theme.spacing.fileManager.breadcrumbHeight,
      minHeight: theme.spacing.fileManager.breadcrumbHeight,
    },
    button: {
      background: "none",
      border: "none",
    },
  },

  key: {
    minWidth: theme.spacing.fileManager.keyMinWidth,
  },

  value: {
    fontWeight: "bold",
  },

  filePreviewWrap: {
    ".mantine-Paper-root": {
      minWidth: theme.spacing.fileManager.paperMinWidth,
      [`@media (max-width: ${theme.breakpoints.tabletMax})`]: {
        minWidth: "auto",
      },
    },
    h2: {
      fontSize: theme.spacing.fileManager.h2FontSize,
      fontFamily: theme.headings.fontFamily.bold,
    },
  },

  filePreview: {
    maxWidth: "calc(100% - 40px)",
  },
  linkLoader: {
    "&:after": {
      borderColor: `${theme.customColors.black} ${theme.customColors.black} ${theme.customColors.black} transparent`,
    },
  },
  alert: {
    padding: 0,
  },
  alertRed: {
    color: theme.customColors.red,
  },
  alertBlock: {
    alignItems: "center",
    gap: theme.spacing.fileManager.linkGap,
    button: {
      top: "0",
    },
  },
  alertInput: {
    width: "100%",
  },
  alertFile: {
    display: "flex",
    ".mantine-Alert-wrapper": {
      marginLeft: "auto",
      marginRight: "auto",
      paddingLeft: "1.5em",
      ".mantine-Alert-body": {
        gap: "0",
      },
      ".mantine-Alert-message": {
        color: theme.customColors.red,
      },
    },
  },
}));
